import * as Sentry from "@sentry/vue";
import Vue from "vue";

export const sentry = () => {
  if (process.env.VUE_APP_ENV !== "local") {
    Sentry.init({
      Vue,
      dsn: process.env.VUE_APP_SENTRY_URL,
      release: "lk-front@" + process.env.VUE_APP_VERSION,
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
      integrations: [
        new Sentry.Replay({
          maskAllText: false,
          blockAllMedia: false
        })
      ]
    });
  }
};
